import {FC} from 'react';
import {Navigate} from 'react-router';

export const AdminDashboard: FC = () => {
  return <Navigate to={'/admin/orders'} />;
};
AdminDashboard.displayName = 'AdminDashboard';
